export enum AppId {
    external = 'external',
    legacy = 'legacy',
    frontOffice = 'front-office',
    backOffice = 'back-office',
    webview = 'webview',
    login = 'login',
    digitalAssistant = 'digital-assistant',
    support = 'support',
    embedded = 'embedded',
    webComponents = 'web-components',
    devPortal = 'dev-portal',
    designer = 'designer',
}

export enum ExternalAppId {
    bkpr = 'bkpr',
}
